import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import {auth} from './config/firebaseInit'
import vuetify from './plugins/vuetify';
import './styles.scss';

Vue.use(Vuetify)

Vue.config.productionTip = false

Vue.prototype.$vueEventBus = new Vue();

/* eslint-disable no-new */
let app;
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      vuetify,
      render: h => h(App)
    })
  }
});
